export const SITE_URL = 'https://starekomputery.pl';
export const SITE_NAME = 'StareKomputery.pl';

export function plainText(value = '', limit = 175) {
  const text = String(value).replace(/<[^>]*>/g, ' ').replace(/!\[[^\]]*\]\([^)]*\)/g, '').replace(/\[([^\]]+)\]\([^)]*\)/g, '$1').replace(/[#*_`>]/g, '').replace(/\s+/g, ' ').trim();
  return text.length > limit ? `${text.slice(0, limit - 1).trimEnd()}…` : text;
}

export function buildPageSeo(pathname, item, { noindex = false, baseUrl = SITE_URL, apiUrl = '' } = {}) {
  const path = pathname === '/' ? '/' : pathname.replace(/\/$/, '');
  const canonical = `${baseUrl.replace(/\/$/, '')}${path}`;
  let title = 'Stare komputery, konsole i historie sprzętu retro';
  let description = 'Kolekcja starych komputerów, konsol i oprogramowania. Zdjęcia eksponatów, parametry techniczne, historia sprzętu i relacje pasjonata retro.';
  let type = 'WebPage';
  if (path === '/collection') {
    title = 'Katalog starych komputerów, konsol i akcesoriów';
    description = 'Przeglądaj kolekcję sprzętu retro. Wyszukaj model, producenta, procesor lub rok produkcji i poznaj zdjęcia oraz dane techniczne eksponatu.';
    type = 'CollectionPage';
  } else if (path === '/links') {
    title = 'Linkoteka retro — dokumentacja, archiwa i społeczności';
    description = 'Przydatne strony o starych komputerach: dokumentacja, archiwa, fora i projekty. Przeglądaj linki według producentów i tematów.';
    type = 'CollectionPage';
  } else if (path.startsWith('/collection/')) {
    title = item?.seoTitle || (item?.Name ? `${item.Name} — zdjęcia i specyfikacja` : 'Karta eksponatu');
    description = item?.seoDescription || (item ? plainText([item.Name, item.manufacturer?.Name, item.RokProdukcji, item.Procesor, item.RAM && `RAM: ${item.RAM}`, item.summary || item.Opis].filter(Boolean).join('. ')) : 'Zdjęcia i dane techniczne eksponatu z kolekcji sprzętu retro.');
    type = 'ItemPage';
  } else if (path.startsWith('/blog/')) {
    title = item?.Title || 'Wpis w archiwum';
    description = item ? plainText(item.Body) || 'Relacja z archiwum pasjonata sprzętu retro.' : 'Relacje, fotografie i notatki ze świata retro.';
  } else if (path.startsWith('/platform/')) {
    title = item?.Name ? `${item.Name} — gry i sprzęt` : 'Platforma retro';
    description = item ? plainText(item.summary) || `Wydania gier i sprzęt przypisany do platformy ${item.Name}.` : 'Platforma zgodności sprzętu retro.';
    type = 'CollectionPage';
  } else if (path.startsWith('/games/')) {
    title = item?.Name || 'Wydanie gry retro';
    description = item ? plainText([item.Name, item.game?.Title, item.platform?.Name, item.publisher, item.year].filter(Boolean).join('. ')) : 'Wydanie gry powiązane z platformą retro.';
    type = 'ItemPage';
  } else if (path !== '/') {
    title = 'Nie znaleziono strony';
    description = 'Ten adres nie prowadzi do istniejącej strony archiwum.';
    noindex = true;
  }
  const photo = item?.coverPhoto || item?.Photos?.[0];
  const photoPath = photo?.formats?.large?.url || photo?.url;
  const image = photoPath ? new URL(photoPath, apiUrl || baseUrl).href : `${baseUrl}/assets/starekomputery-logo.png`;
  const schema = [{ '@context': 'https://schema.org', '@type': type, '@id': `${canonical}#page`, name: title, description, url: canonical, inLanguage: 'pl-PL', isPartOf: { '@id': `${baseUrl}/#website` } }];
  if (path === '/') schema.push({ '@context': 'https://schema.org', '@type': 'WebSite', '@id': `${baseUrl}/#website`, name: SITE_NAME, url: `${baseUrl}/`, inLanguage: 'pl-PL' });
  if (item && (path.startsWith('/collection/') || path.startsWith('/blog/') || path.startsWith('/platform/') || path.startsWith('/games/'))) {
    schema.push({ '@context': 'https://schema.org', '@type': 'BreadcrumbList', itemListElement: [
      { '@type': 'ListItem', position: 1, name: 'Start', item: `${baseUrl}/` },
      ...(path.startsWith('/collection/') ? [{ '@type': 'ListItem', position: 2, name: 'Zbiory', item: `${baseUrl}/collection` }] : []),
      ...(path.startsWith('/platform/') || path.startsWith('/games/') ? [{ '@type': 'ListItem', position: 2, name: 'Gry retro', item: `${baseUrl}/collection` }] : []),
      { '@type': 'ListItem', position: path.startsWith('/collection/') || path.startsWith('/platform/') || path.startsWith('/games/') ? 3 : 2, name: item.Name || item.Title, item: canonical },
    ] });
  }
  return { title: `${title} | ${SITE_NAME}`, description, canonical, image, imageAlt: item?.Name || item?.Title || 'Stare Komputery — logo kolekcji', robots: noindex ? 'noindex, follow' : 'index, follow', schema };
}

export function serializeJson(value) {
  return JSON.stringify(value).replace(/</g, '\\u003c').replace(/>/g, '\\u003e').replace(/&/g, '\\u0026');
}
